import { isSidebarOpenAtom } from '@states/uiAtoms';
import { useAtomValue } from 'jotai';

import SidebarContents from './SidebarContents';
import SidebarHeader from './SidebarHeader';
import styles from './styles.module.scss';

function Sidebar() {
  const isOpen = useAtomValue(isSidebarOpenAtom);
  return (
        <aside className={`${styles.container} ${isOpen ? styles.open : ''}`}>
            <SidebarHeader/>
            <SidebarContents/>
        </aside>
  );
}

export default Sidebar;
